import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FcpSnackbarComponent } from './fcp-snackbar.component';
import { FcpAlertModule } from '../fcp-alert';
import { FcpIconModule } from '../fcp-icon';

@NgModule({
    declarations: [FcpSnackbarComponent],
    imports: [CommonModule, FcpAlertModule, FcpIconModule],
    exports: [FcpSnackbarComponent]
})
export class FcpSnackbarModule {}
